module.exports = __webpack_public_path__ + "img/logoR1.3b0f62c6.png";